import type {
  InstanceSsoProviderRequest,
  InstanceSsoProviderResponse,
} from 'src/api/ProactApiClient';
import {instanceSsoApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const instanceSsoApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    // The endpoint answers 200 with an empty body when the instance has no
    // provider, so a nullable result is the normal case, not an error.
    getSsoProvider: builder.query<InstanceSsoProviderResponse | null, number>({
      queryFn: clientQuery(async (instanceId: number) => {
        const provider = await instanceSsoApiClient.getSsoProvider(instanceId);
        return provider ?? null;
      }),
      providesTags: ['InstanceSso'],
    }),
    createSsoProvider: builder.mutation<
      InstanceSsoProviderResponse,
      InstanceSsoProviderRequest
    >({
      queryFn: clientQuery(request =>
        instanceSsoApiClient.createSsoProvider(request)
      ),
      invalidatesTags: ['InstanceSso'],
    }),
    updateSsoProvider: builder.mutation<
      InstanceSsoProviderResponse,
      InstanceSsoProviderRequest
    >({
      queryFn: clientQuery(request =>
        instanceSsoApiClient.updateSsoProvider(request)
      ),
      invalidatesTags: ['InstanceSso'],
    }),
    adoptSsoProvider: builder.mutation<InstanceSsoProviderResponse, number>({
      queryFn: clientQuery((instanceId: number) =>
        instanceSsoApiClient.adoptSsoProvider(instanceId)
      ),
      invalidatesTags: ['InstanceSso'],
    }),
    deleteSsoProvider: builder.mutation<void, number>({
      queryFn: voidClientQuery((instanceId: number) =>
        instanceSsoApiClient.deleteSsoProvider(instanceId)
      ),
      invalidatesTags: ['InstanceSso'],
    }),
  }),
});

export const {
  useGetSsoProviderQuery,
  useCreateSsoProviderMutation,
  useUpdateSsoProviderMutation,
  useAdoptSsoProviderMutation,
  useDeleteSsoProviderMutation,
} = instanceSsoApi;
